// pusher-js (pinned to 3.2.1 to match the previously vendored build). Under
// esbuild it resolves as CommonJS and does not self-attach to window, so the
// legacy code that uses the bare `Pusher` global needs it exposed here.
import Pusher from "pusher-js"

window.Pusher = Pusher

export default Pusher
